module.exports = __webpack_public_path__ + "img/Fregier.83127a8c.png";